import React, {Component} from "react";
import PopupClose from "../buttons/popup-close";
import MentItem from "../elements/ment.item";
import {type_ment} from "../../../vars/rd";

class MentDetail extends Component {
    constructor(props) {
        super(props);

        this.callback = props.callback;
        this.callbackLoaded = props.callbackLoaded;
        this.state = {
            data: props.data || {},
            close: false
        }
    }

    componentDidMount() {
        this.mounted = true;
        if(this.callbackLoaded) this.callbackLoaded.call(null, this);
    }

    componentWillUnmount() {
        this.mounted = false;
        this.callback = null;
        this.callbackLoaded = null;
    }

    /**
     * @returns {DaoMent}
     */
    get data() {
        return this.state.data;
    }

    /**
     * 창닫기
     */
    close(reset=false) {
        const data = reset ? {} : (this.state.data || {});
        if(this.callback) this.callback(data);
        if (this.mounted) {
            this.setState({ close: true });
        }
    }

    render() {
        return (
            <div className="popup-broad">
                <h2>
                    스크립트
                    <PopupClose close={this.state.close} />
                </h2>
                <div className="popup-content">
                    <MentItem data={this.data} type={type_ment.popup} />
                    <div className="text" dangerouslySetInnerHTML={{__html: this.data.script}}>
                    </div>
                </div>
            </div>
        );
    }
}

export default MentDetail;


// WEBPACK FOOTER //
// ./src/pages/components/popup/ment.detail.jsx